// extracted by mini-css-extract-plugin
module.exports = {"viewRoot":"ZrTa0VIB"};